import React from "react";
import useIfLoggedIn from "../../../hooks/useIfLoggedIn";

export default function LoginPath({ children }) {
  useIfLoggedIn();
  return <div>{children}</div>;
}
